package com.oscarherreros.appcalculo.web

import kotlinx.browser.document
import kotlinx.browser.window

fun main() {
    val texts = textsFor(window.navigator.language)
    document.documentElement?.setAttribute("lang", texts.locale)
    document.title = "Kalkulia · " + texts.dailyChallenge
    val root = document.getElementById("app") ?: return
    DailyPage(root, texts, DailyStore(BrowserStore())).start()
}
